export default __webpack_public_path__ + "static/media/K_Kurumi.f6b48185.svg";